import { useCallback } from 'react';

import { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';
import { RECOMMENDATION_ENGINES } from '@/domains/productDiscovery/Recommendation/constants';
import {
  hasError,
  isFetching,
  recommendationConfigSelector,
  recommendationSelector,
} from '@/domains/productDiscovery/Recommendation/selectors/recommendation.selectors';

export const useRecommendationSelector = (
  recoEngineName: RECOMMENDATION_ENGINES,
) => {
  const memoRecommendationConfigSelector = useCallback(
    (state: Partial<SpartacuxProductDiscoveryDomainState>) => {
      return recommendationConfigSelector(state, recoEngineName);
    },
    [recoEngineName],
  );

  const memoRecommendationSelector = useCallback(
    (state: Partial<SpartacuxProductDiscoveryDomainState>) => {
      return recommendationSelector(state, recoEngineName);
    },
    [recoEngineName],
  );

  return {
    hasError,
    isFetching,

    recommendationConfigSelector: memoRecommendationConfigSelector,
    recommendationSelector: memoRecommendationSelector,
  };
};
